import React, { useState } from "react";
import { NUMBER_TO_WORDS } from "../../data/DataMap";

function DataCard({ numberData, index }) {
  const response = NUMBER_TO_WORDS[numberData];
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked);
  };

  return (
    <div
      key={index}
      className=" bg-white p-1 px-2 rounded-lg shadow-md mx-1 m-2 flex flex-col cursor-pointer"
    >
      <div onClick={handleClick} className="flex-grow">
        {response.map((item, i) => {
          const word = item.word.split(" ")[0];
          const hindiWord = item.word.split(" ")[1];
          return (
            <div className="flex flex-col items-center">
              <div key={i} className="flex items-center">
                <div className="font-bold flex-grow">{numberData}</div>
                <div className="bg-blue-600 p-1 rounded-lg m-2 text-sm text-white uppercase">
                  {item.abbr}
                </div>
                <div className="uppercase font-sans">{word}</div>
              </div>
              {clicked === true ? (
                <div className="uppercase font-sans">{hindiWord}</div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DataCard;
